'use client';

import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import type { TrailId } from '@alltrails/types/TrailId';

const SignUpModal = dynamic(() => import('@alltrails/user-auth/components/SignUpModal'), { ssr: false });

type Props = {
  trailId: TrailId;
};

// Opens the SignUpModal once when the user scrolls past one viewport. Dismissible:
// closing the modal lets the user keep scrolling and it never reopens.
export default function DismissibleScrollWall({ trailId }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  // Once the wall has fired, never reopen it regardless of further scrolling.
  const hasFiredRef = useRef(false);

  useEffect(() => {
    const onScroll = () => {
      if (hasFiredRef.current) {
        return;
      }
      if (window.scrollY >= window.innerHeight) {
        hasFiredRef.current = true;
        setIsOpen(true);
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <SignUpModal
      closeModal={() => setIsOpen(false)}
      deeplinkData={{ pageId: trailId, pageType: 'trail' }}
      isOpen={isOpen}
      onSuccess={() => setIsOpen(false)}
      trigger="scroll auth"
      upsellTrigger="scroll auth"
    />
  );
}
